import {
  Alert,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { useState, type FormEvent } from 'react';

import { describeLoginFailure, useLogin } from '../features/auth';

export function LoginPage({ notice }: { notice?: string }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useLogin();

  function submit(event: FormEvent) {
    event.preventDefault();
    login.mutate({ email: email.trim(), password });
  }

  return (
    <Center h="100%" p="md">
      <Paper withBorder p="xl" w={380} component="form" onSubmit={submit}>
        <Stack>
          <Title order={3}>Aura — админ</Title>
          {notice && !login.isError ? <Alert color="yellow">{notice}</Alert> : null}
          <TextInput
            label="Email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.currentTarget.value)}
          />
          <PasswordInput
            label="Пароль"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.currentTarget.value)}
          />
          {login.isError ? (
            <Alert color="red" role="alert">
              {describeLoginFailure(login.error)}
            </Alert>
          ) : null}
          <Button type="submit" loading={login.isPending}>
            Войти
          </Button>
          <Text size="xs" c="dimmed">
            Вход только для аккаунтов с ролью администратора.
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
}
